<template>
  <div class="hmseries-and-footer">
    <hmserieseng></hmserieseng>
    <scfootereng></scfootereng>
  </div>
</template>

<script>

 export default {
   name: 'hmcosmeticseng',
   components: {
     hmserieseng: () => import('../components/HMseriesEng.vue'),
     scfootereng: () => import('../components/scFooterEng.vue')
   },
 }
</script>

<style lang="scss" scoped>
 $page-width: 960px;
 a {
   text-decoration: none;
 }

 .hmseries-and-footer {
   margin-top: 80px;
 }

 @media (max-width: 600px) {
   .hmseries-and-footer {
     margin-top: 20px;
   }
 }
</style>
